import { render, staticRenderFns } from "./Продажы по группам.vue?vue&type=template&id=7fbf5ebe&scoped=true&"
import script from "./Продажы по группам.vue?vue&type=script&lang=js&"
export * from "./Продажы по группам.vue?vue&type=script&lang=js&"
import style0 from "./Продажы по группам.vue?vue&type=style&index=0&id=7fbf5ebe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf5ebe",
  null
  
)

export default component.exports